"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.START_SEARCH = exports.FAVORITES_OVERVIEW_OPEN = exports.CLICK_SUBCATEGORY_LINK = exports.CLICK_NOTIFICATION_ICON = exports.CLICK_CATEGORY_BRAND = exports.CLICK_CATALOGUE_DETAIL = exports.CLICK_CATALGOUE = exports.CLICK_BURGER_MENU = exports.ACCEPT_LANGUAGE = void 0;
const CLICK_CATALGOUE = exports.CLICK_CATALGOUE = ['open_ecatalogue', 'Main menu sidebar'];
const CLICK_CATALOGUE_DETAIL = exports.CLICK_CATALOGUE_DETAIL = ['open_ecatalogue', 'Main menu content'];
const CLICK_BURGER_MENU = exports.CLICK_BURGER_MENU = ['open_main_menu', 'Top navigation'];
const CLICK_CATEGORY_BRAND = exports.CLICK_CATEGORY_BRAND = ['select_brand', 'Main menu content'];
const START_SEARCH = exports.START_SEARCH = ['search_start', 'Search 1'];
const FAVORITES_OVERVIEW_OPEN = exports.FAVORITES_OVERVIEW_OPEN = ['favorites_overview_open'];
const CLICK_NOTIFICATION_ICON = exports.CLICK_NOTIFICATION_ICON = ['notifications', 'open_notification_overview'];

// Cannot use the one from ori/fetching due to not capital A and L in accept-language
const ACCEPT_LANGUAGE = exports.ACCEPT_LANGUAGE = 'Accept-Language';
const CLICK_SUBCATEGORY_LINK = exports.CLICK_SUBCATEGORY_LINK = ['menu_side_select'];